var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlayFlame = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52 27.134C52.6667 27.5189 52.6667 28.4811 52 28.866L16.75 49.2176C16.0833 49.6025 15.25 49.1214 15.25 48.3516L15.25 7.64841C15.25 6.8786 16.0833 6.39748 16.75 6.78238L52 27.134Z",
    stroke: "url(#paint0_linear_10304_7464)",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10304_7464",
    x1: 55.5,
    y1: 28,
    x2: 0.500006,
    y2: 28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E01BE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBE1E"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlayFlame);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/play-flame.bf55f1f4852fd55db3d89e4a3878a929.svg";